import MemoryStorage from "./memory.storage";

let SessionStorage;

try {
    SessionStorage = sessionStorage;
} catch (e) {
    SessionStorage = new MemoryStorage();
}

export default SessionStorage;